<div class="modal-header">
  <button type="button" class="close" ng-click="ctrl.close()">×</button>
  <h4 class="modal-title">Selecione o(s) produto(s)</h4>
</div>
<div class="modal-body product-modal">
  <div ng-if="ctrl.hasServerFilter" class="m-b-sm">
    <div class="input-group">
      <input class="form-control" ng-model="ctrl.filter" placeholder="Digite e clique em Buscar ou pressione Enter..." ng-keydown="ctrl.onFilterKeydown($event)">
      <span class="input-group-btn">
        <button type="button" class="btn btn-default" ng-click="ctrl.search()" ng-disabled="ctrl.loadingProducts || ctrl.filter.length < ctrl.minSearchLength">
          <i class="fa" ng-class="ctrl.loadingProducts ? 'fa-spinner fa-spin' : 'fa-search'"></i> Buscar
        </button>
      </span>
    </div>
    <small ng-if="ctrl.filter.length > 0 && ctrl.filter.length < ctrl.minSearchLength" class="text-muted">Digite pelo menos {{ctrl.minSearchLength}} caracteres para buscar</small>
  </div>
  <input ng-if="!ctrl.hasServerFilter" class="m-b-sm form-control" ng-model="ctrl.filter" placeholder="Filtro...">
  <table class="table table-hover" ng-hide="ctrl.loadingProducts">
    <thead>
      <tr>
        <th></th>
        <th ng-class="{'full-width': !ctrl.canSeeStock()}">Produto</th>
        <th ng-if="ctrl.canSeeStock()">Estoque</th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat="prod in ctrl.products | filter:(ctrl.hasServerFilter ? {} : {descricao: ctrl.filter})" ng-class="{info: ctrl.selected.includes(prod)}" class="pointer" ng-click="ctrl.toggle(prod)">
        <td>
          <input type="checkbox" name="prods[]" ng-checked="ctrl.selected.includes(prod)" ng-if="ctrl.allowMultiple">
          <input type="radio" name="prod" ng-checked="ctrl.selected.includes(prod)" ng-if="!ctrl.allowMultiple">
        </td>
        <td ng-class="{'full-width': !ctrl.canSeeStock()}">{{prod.descricao}}</td>
        <td ng-if="ctrl.canSeeStock(prod)">
          <small ng-bind-html="'Físico: ' + (prod.saldo_fisico | number:4) + ' ' + (prod.unidade.abreviatura)"></small>
          <small ng-bind-html="' / Receber: ' + (prod.saldo_receber | number:4) + ' ' + (prod.unidade.abreviatura)"></small>
          <small ng-bind-html="' / Em uso: ' + (prod.saldo_em_uso | number:4) + ' ' + (prod.unidade.abreviatura)"></small>
        </td>
      </tr>
    </tbody>
  </table>
</div>
<div class="modal-footer text-right">
  <button type="button" class="btn btn-white" ng-click="ctrl.close()">Cancelar</button>
  <button type="button" class="btn btn-primary" ng-click="ctrl.save()">Selecionar</button>
</div>